import { createFileRoute } from '@tanstack/react-router'
import { AvatarDetail } from '../../../../../features/admin/AvatarDetail'

/* ───── Route Definition ───── */

export const Route = createFileRoute(
  '/_authenticated/admin/collection/avatars/$id',
)({
  component: AvatarDetailRoute,
})

/* ───── Route Component ───── */

function AvatarDetailRoute() {
  const { id } = Route.useParams()
  return <AvatarDetail avatarId={id} />
}
